import { CATEGORIES, articleHref } from "../data/articles.js";
import { formatDate } from "../lib/editApi.js";

// The guide card used on the homepage, The Edit index, and category pages.
// One component so a change to card design lands everywhere at once.
export default function ArticleCard({ article, className = "" }) {
  const label = CATEGORIES[article.category]?.label || article.tag || "Guide";
  return (
    <a href={articleHref(article)} className={`card overflow-hidden group flex flex-col ${className}`}>
      <div className="aspect-[4/3] overflow-hidden bg-sand-100">
        {article.img && (
          <img
            src={article.img}
            alt={article.title}
            loading="lazy"
            style={{ objectPosition: article.imgPosition || "center center" }}
            className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
            onError={e => { e.currentTarget.style.display = "none"; }}
          />
        )}
      </div>
      <div className="flex flex-1 flex-col p-6">
        <span className="eyebrow">{label}</span>
        <h3 className="mt-2 font-display text-xl leading-snug text-ink group-hover:text-ocean-700">{article.title}</h3>
        {article.excerpt && <p className="prose-body mt-2 text-sm line-clamp-3">{article.excerpt}</p>}
        {article.date && <span className="mt-4 text-xs text-ink-muted">{formatDate(article.date)}</span>}
      </div>
    </a>
  );
}

export function CategoryChips({ active }) {
  return (
    <div className="flex flex-wrap gap-2">
      <a href="/edit/" className={`chip ${!active ? "bg-ocean-700 text-white" : ""}`}>All</a>
      {Object.entries(CATEGORIES).map(([slug, meta]) => (
        <a key={slug} href={`/${slug}/`} className={`chip ${active === slug ? "bg-ocean-700 text-white" : ""}`}>
          {meta.label}
        </a>
      ))}
    </div>
  );
}
